import axios, { AxiosResponse } from "axios";
import { ObjectFromEnvelope } from "../../../services/config.service";
import { User } from "../models/user-model";
import { configService } from "./config.service";

class UserService {
  constructor() {
    // console.log("creating new instance of user.service");
  }

  async updateCurrentUser(user: User): Promise<User> {
    return new Promise<User>((resolve, reject) => {
      const path = "users/";
      axios
        .put<User>(configService.APIUrl(path + user.id + ".json"), user.convertToPutObject())
        .then((response: AxiosResponse) => {
          resolve(User.fromJSON(ObjectFromEnvelope<User>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  public fetchCurrentUser(): Promise<User> {
    return new Promise<User>((resolve, reject) => {
      axios
        .get(configService.APIUrl("users/current.json"))
        .then((response: AxiosResponse) => {
          resolve(User.fromJSON(ObjectFromEnvelope<User>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public setCurrentInstitution(institutionCode: number, role: number): Promise<any> {
    return new Promise<User>((resolve, reject) => {
      axios
        .post(
          configService.APIUrl("select_institution.json?code=" + institutionCode + "&role=" + role)
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async changePassword(query: { password: string; new_password: string }): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      axios
        .post(configService.APIUrl("change_password.json"), query)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

// export a singleton instance in the global namespace
export const userService: UserService = new UserService();
